import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ExternalSettings } from '../../../services/external-settings/external-settings.interface';
import { ExternalSettingsService } from '../../../services/external-settings/external-settings.service';
import { ResponsiveDesignService } from '../../../services/responsive-design/responsive-design.service';
import { PlatformService } from 'src/app/system/utility/platform.service';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';

/** Result of the App Authenticator needs-activation choice dialog. */
export type AppAuthenticatorNeedsActivateChoice = 'back' | 'sendCode' | 'continue';

export interface AppAuthenticatorNeedsActivateDialogData {
  /** Optional title override; defaults to ACTIVATE_TITLE. */
  title?: string;
}

@Component({
  selector: 'app-app-authenticator-needs-activate',
  templateUrl: './app-authenticator-needs-activate.component.html',
  styleUrls: ['./app-authenticator-needs-activate.component.less'],
  standalone: false,
})
export class AppAuthenticatorNeedsActivateComponent implements OnInit {

  UIUtilityService: any = UIUtilityService;
  externalSettings!: ExternalSettings;
  readonly isBrowser = PlatformService.isBrowser();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AppAuthenticatorNeedsActivateDialogData,
    public dialogRef: MatDialogRef<AppAuthenticatorNeedsActivateComponent, AppAuthenticatorNeedsActivateChoice>,
    private srvES: ExternalSettingsService,
    protected srvRpDesign: ResponsiveDesignService,
  ) { }

  ngOnInit(): void {
    this.srvES.externalSettings$.subscribe((settings) => {
      this.externalSettings = settings;
    });
  }

  onBack(): void {
    this.dialogRef.close('back');
  }

  onSendCode(): void {
    this.dialogRef.close('sendCode');
  }

  onContinue(): void {
    this.dialogRef.close('continue');
  }

  onCancel(): void {
    this.dialogRef.close('back');
  }
}
